module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "Fcenter"
  }, [_c('div', {
    staticClass: "about"
  }, [_c('h1', {
    staticClass: "aboutYi"
  }, [_vm._v("关于以诺")]), _vm._v(" "), _c('ul', {
    staticClass: "zhAbout"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/AboutEnoch"
    }
  }, [_vm._v("以诺源起")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/AboutEnoch"
    }
  }, [_vm._v("校长寄语")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "send zhAbout"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/AboutEnoch"
    }
  }, [_vm._v("愿景与使命")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/AboutEnoch"
    }
  }, [_vm._v("我们的服务")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "contactOur"
  }, [_c('h1', {
    staticClass: "aboutYi"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('p', {
    staticClass: "dizhi"
  }, [_c('Icon', {
    staticClass: "juli",
    attrs: {
      "type": "ios-location"
    }
  }), _vm._v("上海市闵行区申滨南路1226号诺亚财富中心")], 1), _vm._v(" "), _c('p', [_c('Icon', {
    staticClass: "juli",
    attrs: {
      "type": "ios-email"
    }
  }), _vm._v("enoch.service@noahwm.com")], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "clears"
  }), _vm._v(" "), _c('p', {
    staticClass: "foot"
  }, [_vm._v("Copyright © 2017 -  " + _vm._s(new Date().getFullYear()) + " 以诺教育科技（上海）有限公司 版权所有；\n\t\t\t\t"), _c('img', {
    staticStyle: {
      "display": "inline",
      "width": "20px",
      "height": "22px",
      "margin-left": "10px",
      "margin-right": "2px",
      "vertical-align": "middle",
      "position": "relative",
      "top": "-2px"
    },
    attrs: {
      "src": require("../../assets/police.png")
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://beian.mps.gov.cn/#/query/webSearch?code=31011202022626",
      "rel": "noreferrer",
      "target": "_blank"
    }
  }, [_vm._v("沪公网安备31011202022626号；")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/#/Integrated/recordQuery",
      "rel": "noreferrer",
      "target": "_blank"
    }
  }, [_vm._v("沪ICP备15049725号-1；")]), _vm._v(" "), _c('img', {
    staticClass: "wangjing",
    attrs: {
      "src": require("../../assets/wangjing.jpg"),
      "title": "亲爱的市民朋友，上海警方反诈劝阻电话“962110”系专门针对避免您财产被骗受损而设，请您一旦收到来电，立即接听"
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contactPh"
  }, [_c('p', {
    staticClass: "phonenumber"
  }, [_vm._v("400-820-0025-3")]), _vm._v(" "), _c('p', {
    staticClass: "timershow"
  }, [_vm._v("周一至周五9:00-18:00")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "QR"
  }, [_c('img', {
    staticClass: "footQR",
    attrs: {
      "src": require("../../assets/QR.jpg")
    }
  }), _vm._v(" "), _c('p', [_vm._v("扫一扫，关注我们")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd25510a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bottom/Bottom.vue
// module id = 560
// module chunks = 1